/**
 * author: 582196894@qq.com
 * date: 2017/11/29 rebuild
 * desc: fetch
 */
import util from './util'
import Cookies from 'js-cookie'
import config from '@/configs/config'

const GET_OUT_URL = `${config.apis.WX_SILENT}`

// const API_URLS = ['api.tuhu.cn', 'api.tuhu.work', 'apidev.tuhu.work', 'by.tuhu.cn', 'activity-api.tuhu.cn']

// const NEED_PROXYS = ['item.tuhu.cn']

const counts = {}

let lastPageId = ''

let loginPromise = null

let tokenLoaded = false

function getCookie(key) {
    const reg = new RegExp(key + '=(.+?)(?:;|$)')
    const match = document.cookie.match(reg)

    return (match && match[1]) || ''
}

class Fetch {
  static fetch = (url, opts, other) => {
    const instance = new Fetch(url, opts, other)
    return instance.fetch()
  }

  constructor(url, opts = {}, other = {}) {
	const cookie = localStorage.getItem('shop-token') ? localStorage.getItem('shop-token') : Cookies.get('x-auth-token')

	this.url = url

	opts.credentials = 'include'

    this.opts = opts
    this.opts.headers = Object.assign({
		'Accept': '*/*',
		'Access-Control-Allow-Credentials': true,
		'x-auth-token': cookie
	},
	(url.indexOf('upload') > -1 || url.indexOf('vin/image/ocr') > -1 || url.indexOf('vin/ocr') > -1) || url.indexOf('imageListToPdf') > -1 ? {} : {'Content-Type': 'application/json'},
	// 上传接口不需要设置content-type
	opts.headers)

    this.other = other

    this.count = 0

    this.timeout = false

    this.timeoutId = null

    this.init()
  }

  init() {
    this.other = Object.assign({
      session: false,
      json: true,
      timeout: 30,
      limit: 2,
      status: true,
      force: true,
      query: {},
      phone: '' // 401跳转登陆->自动填写手机号并发送验证码
    }, this.other)

    // this.autoSession()
	// if (this.opts.method === 'post') {
		this.setProxy()
	// }
    this.setQuery()
    this.url = tuhu.config.apiFilter(this.url)
  }

  fetch() {
    const other = this.other

    return Promise.race([new Promise((resolve, reject) => {
      this.timeoutId = setTimeout(() => {
        this.timeout = true

        this.endCount()

        this.hideLoading()

        this.showError('网络超时')

        reject({
          url: this.url,
          code: -2,
          message: '网络超时'
        })
      }, other.timeout * 1000)
    }), this._fetch()])
  }

  async _fetch() {
    const url = this.url
    const opts = this.opts
    const other = this.other

    this.count++
    this.pageCount()

    return fetch(url, opts).then(async (res) => {
      clearTimeout(this.timeoutId)
      if (this.timeout) {
        return
      }

      this.endCount()
      if (res.headers.get('x-auth-token')) {
        localStorage.setItem('shop-token', res.headers.get('x-auth-token'))
      }
      if (res.code === '401' && !other.force) {
        localStorage.setItem('shop-token', '')
        Cookies.remove('x-auth-token')
        this.hideLoading()

        return res
      }

      if (res.code === '401') {
        localStorage.setItem('shop-token', '')
        Cookies.remove('x-auth-token')
        if (!loginPromise) {
          this.hideLoading()
          // openId 只有后端（无次用户）重定向登陆页有
          if (tuhu.device.isWeixin && !tuhu.getParam('openId') && !(location.href.indexOf('localhost') > -1)) {
            location.href = `${GET_OUT_URL}?url=${encodeURIComponent(location.href)}&source=3`

            loginPromise = null
          } else {
            loginPromise = await new Promise((resolve) => {
              tuhu.navigateTo({
                url: '/pages/_login/index',
                query: {
                  openId: tuhu.device.isWeixin ? tuhu.getParam('openId') : ''
                },
                data: {
                  resolve: resolve
                }
              })
            })
          }
        }

        return loginPromise.then((data) => {
          loginPromise = null

          if (!data.islogin) {
            this.showError('用户信息缺失')

            return Promise.reject({
              url: this.url,
              code: -4,
              message: '用户信息缺失'
            })
          }

        //   this.insertSession()
          return this._fetch()
        })
      }

      if (res.ok) {
        this.hideLoading()

        if (other.json) {
          return res.json().then((data) => {
            if (data.code !== undefined) {
              data.Code -= 0
            }

            return data
          }).catch((e) => {
            this.showError(process.env.NODE_ENV === 'development' ? e.message : '程序异常')

            return Promise.reject({
              url: this.url,
              code: -1,
              message: e.message
            })
          })
        }

        return res
      }

      if (this.count < other.limit) {
        return this._fetch()
      }

      this.hideLoading()

      return Promise.reject({
        url: this.url,
        code: -3,
        message: '接口异常 状态码:' + res.code
      })
    }).then((data) => {
      return data
    })
  }

  showError(msg) {
    if (!this.other.status) {
      return
    }

    tuhu.toast(msg || '网络异常,请稍候再试', 1000)
  }

  endCount() {
    if (!this.other.status) {
      return
    }

    counts[lastPageId].end++
  }

  pageCount() {
    if (!this.other.status) {
      return
    }

    const currentPageId = location.pathname
    if (counts[lastPageId] && lastPageId !== currentPageId) {
      delete counts[lastPageId]
    }

    if (!counts[currentPageId]) {
      counts[currentPageId] = {
        begin: 0,
        end: 0
      }
    }

    if (counts[currentPageId].begin < 1) {
      tuhu.showIndicator()
    }

    counts[currentPageId].begin++

    lastPageId = currentPageId
  }

  hideLoading() {
    const other = this.other

    if (!other.status) {
      return
    }

    setTimeout(() => {
      if (counts[lastPageId].end >= counts[lastPageId].begin) {
        tuhu.hideIndicator()
      }
    }, 300)
  }

  setProxy() {
    let url = this.url

    if (process.env.NODE_ENV === 'development') {
      url = url.replace(/.*?\/\/.+?\//, '/')
    }

    this.url = url
  }

  setQuery() {
    let url = this.url
    const str = $.param(this.other.query)
    // const query = this.other.query

    // const strArr = []
    // for (let i in query) {
    //   if (query.hasOwnProperty(i)) {
    //     strArr.push(`${i}=` + encodeURIComponent(query[i]))
    //   }
    // }
    if (str) {
      url += url.indexOf('?') > 0 ? '&' + str : '?' + str
    }

    this.url = url
  }
}

export default Fetch



// WEBPACK FOOTER //
// ./lib/commons/fetch.js